<template>
  <div class="page" style="overflow: auto">
    <navigator-menu :parentMsg="project_id"></navigator-menu>
    <el-card class="label-body">
      <div style="width:100%; font-weight: bold; font-size: 30px; text-align:center;">Pre Annotation Settings</div>
      <el-divider />
      <el-container >
        <el-card class="box-card" shadow="never" style="width: 1500px; background-color: rgba(255, 255, 255, 0.7);">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold; font-size: 20px;">Knowledge Extraction Models Recommendation</span>
              <el-tooltip
                  effect="dark"
                  content="Batch Annotation Model"
                  placement="top"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-question-circle-fill" viewBox="0 0 16 16" style="margin-top:10px;">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                </svg>
              </el-tooltip>
          </div>

          <div class="row">
            <div class="col">
              <p>Please select the number of Datasets to match (the top m Datasets with the highest similarity):</p>
              <el-input-number v-model="n" :min="1" class="input-demo"></el-input-number>
            </div>
            <div class="col">
              <p>Please select the number of models to match (top n best performing models):</p>
              <el-input-number v-model="m" :min="1" class="input-demo"></el-input-number>
            </div>
          </div>
          <el-button type="primary" @click="getRecommendations">Get Recommendation</el-button>
          <div class="row">
            <div class="col">
              <el-table :data="datasets" style="width: 100%;background-color: rgba(255, 255, 255, 0.7);" @sort-change="sortDatasets" class="table-demo" @row-click="selectDataset" :row-class-name="rowClassName">
                <el-table-column prop="name" label="Dataset Name" sortable></el-table-column>
                <el-table-column prop="description" label="Description" sortable></el-table-column>
                <el-table-column prop="similarity" label="Similarity" sortable></el-table-column>
              </el-table>
            </div>
            <div class="col">
              <el-table :data="models" style="width: 100%;background-color: rgba(255, 255, 255, 0.7);" @sort-change="sortModels" class="table-demo">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Model Name" sortable></el-table-column>
                <el-table-column prop="precision" label="precision" sortable></el-table-column>
                <el-table-column prop="f1" label="F1-score" sortable></el-table-column>
                <el-table-column prop="recall" label="Recall" sortable></el-table-column>
              </el-table>
            </div>
          </div>
          <p v-if="selectedDataset">Chosen Dataset: {{ selectedDataset.name }}</p>
          <p v-if="selectedModels.length > 0">Chosen Model: {{ selectedModels.map(model => model.name).join(', ') }}</p>
          <el-button type="primary" @click="submitSelections">Submit Choice</el-button>
        </el-card>
      </el-container>
      <el-divider border-style="dashed" />
      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Pre Annotation Percentage(%)</div></el-col>
        <el-col :span="1">
          <el-tooltip
              effect="dark"
              content="Pre Annotation Text/Total Text(%)"
              placement="top"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-question-circle-fill" viewBox="0 0 16 16" style="margin-top:10px;">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
            </svg>
          </el-tooltip>
        </el-col>
        <el-col :span="3" style="margin-right:80px;">
          <el-input-number
              v-model="PreSettings.preSetPercent"
              :min="5"
              :step="5"
              default-active="5"
              controls-position="right"
              size="large"
          />
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>

      <el-row :gutter="10" style="height: 80px;">
        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Choose LLM</div></el-col>
        <el-col :span="1">
          <el-tooltip
              effect="dark"
              content="LLM used during Pre Annotation Stage"
              placement="top"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-question-circle-fill" viewBox="0 0 16 16" style="margin-top:10px;">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
            </svg>
          </el-tooltip>
        </el-col>
        <el-col :span="12">
          <el-radio-group v-model="selectLLM" >
            <el-radio label="ChatGPT（Online）"></el-radio>
            <el-radio label="Xiaobei（Local）"></el-radio>
            <el-radio label="Baichuan-13B（Local）"></el-radio>
          </el-radio-group>
        </el-col>
        <el-divider border-style="dashed" />
      </el-row>
<!-- Pre Annotation达标准确率比较迷惑，先不使用  -->
<!--      <el-row :gutter="10" style="height: 80px;">-->
<!--        <el-col :span="6" style="font-weight: bold; font-size: 20px;"><div>Pre Annotation达标准确率(%)</div></el-col>-->
<!--        <el-col :span="1">-->
<!--          <el-tooltip-->
<!--              effect="dark"-->
<!--              content="完成Pre Annotation阶段后，SOTA模型在标注Dataset上的准确率"-->
<!--              placement="top"-->
<!--          >-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-question-circle-fill" viewBox="0 0 16 16" style="margin-top:10px;">-->
<!--              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>-->
<!--            </svg>-->
<!--          </el-tooltip>-->
<!--        </el-col>-->
<!--        <el-col :span="3" style="margin-right:80px;">-->
<!--          <el-input-number-->
<!--              v-model="PreSettings.preSetAcc"-->
<!--              :min="5"-->
<!--              :step="5"-->
<!--              default-active="5"-->
<!--              controls-position="right"-->
<!--              size="large"-->
<!--          />-->
<!--        </el-col>-->
<!--        <el-divider border-style="dashed" />-->
<!--      </el-row>-->


<!--      <el-button type="success" @click="savePreSettings" style="margin-left:30%;" :disabled="saved">保存</el-button>-->
      <el-button type="success" @click="savePreSettings" style="margin-left:30%;" >Save</el-button>
      <span>&nbsp;&nbsp;</span>
      <el-dialog
          title="提示"
          v-model:propName="settingVisible"
          width="30%"
          :before-close="handleClose">
        <span>这是一段信息</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
      <el-tooltip
          effect="dark"
          content="Settings cannot be changed after saving"
          placement="top"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-question-circle-fill" viewBox="0 0 16 16" style="margin-top:10px;">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
        </svg>
      </el-tooltip>
<!--      <el-button type="success" @click="resetPreSettings" style="margin-left:10%;" :disabled="saved">重置</el-button>-->
      <el-button type="success" @click="resetPreSettings" style="margin-left:10%;" >Reset</el-button>
    </el-card>
  </div>
</template>

<script>
import NavigatorMenu from "./ProNavigation";
import axios from 'axios'
import WOW from "wow.js";
import { QuestionFilled } from "@element-plus/icons";
export default {
  name: "Settings",
  components: {
    NavigatorMenu,
    QuestionFilled,
  },
  data(){
    return{
      csrfToken: '',
      n: 3,
      m: 3,
      datasets: [
        {name: "CBLUE2.0", description:"Opensource Entity Extraction Medical Dataset",similarity: 0.43},
        {name: "CBLUE3.0", description:"Opensource Entity Extraction Medical Dataset",similarity: 0.49},
        {name: "finance_sina",description:"Sina Finance Entity Extraction Dataset", similarity: 0.07},
      ],
      models: [
        {name: "bert-crf", precision: 0.95, f1: 0.9, recall: 0.88},
        {name: "chinese-bert", precision: 0.92, f1: 0.89, recall: 0.85},
        {name: "RoBERTa-adapter", precision: 0.88, f1: 0.88, recall: 0.82},
      ],
      selectedDataset: null,
      selectedModels: [],
      PreSettings: {
        preSetPercent: 10,
        preSetAcc: 80
      },
      settings: {
        model_name:'bert_span', // 选择的模型名字
        model_config:'string', // 模型参数
        optimizer_config:'string', // 优化器参数
        rule: true, // 规则匹配
        onlinelearning: false, // 连接服务器进行学习,Pre Annotation阶段先不要连接服务器学习，以免每次返回时间太长
        history: true, // 历史字典匹配
        active: 1, // 主动学习方式
        acquire: 5, // 每轮标注规模，先Settings的大一点
      },
      selectLLM:'ChatGPT（在线）',
      parameterJson:'', // 用于将参数转化为json字符串的形式
      // selectedModel: {}, // 选中的模型
      modelDescription:'',// 当前模型的简短描述
      allModel:[], // 返回模型库的全部模型
      settingVisible: false,
      saved:false, // 检查Settings是否已经初始化完成并保存
      project_id: this.$route.params.project_id,
      embeddingModelOptions: ['Glove(default)'],
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] === "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    // this.csrfToken = response.data.token;
    console.log('csrfToken:'+this.csrfToken)

    var url = window.location.href
    var begin = url.indexOf('/project/') + 9
    var end = url.indexOf('/premark')
    this.project_id = url.slice(begin, end)

    this.getPreSettings()

  },
  mounted() {
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    wow.init();
  },
  methods: {
    handleUploadSuccess(response, file) {
      // 处理Upload Success的回调
    },
    getRecommendations() {
      // 向后端发送请求，获取推荐的Dataset和模型
    },
    sortDatasets({ prop, order }) {
      // 根据用户的选择排序Dataset
    },
    sortModels({ prop, order }) {
      // 根据用户的选择排序模型
    },
    selectDataset(row) {
      this.selectedDataset = row;
      // 基于选择的Dataset获取相应的模型
      console.log(row)
      if (row.name === "CBLUE2.0"){ // 先写个静态页面
        this.models = [
          {name: "bert-crf", precision: 0.70, f1: 0.68, recall: 0.66},
          {name: "chinese-bert", precision: 0.71, f1: 0.68, recall: 0.66},
          {name: "RoBERTa-adapter", precision: 0.73, f1: 0.69, recall: 0.65},
        ]
      }
      else if (row.name === "finance_sina"){
        this.models = [
          {name: "bert_crf", precision: 0.87, f1: 0.83, recall: 0.82},
          {name: "bert_span", precision: 0.90, f1: 0.87, recall: 0.83},
          {name: "bert_softmax", precision: 0.91, f1: 0.88, recall: 0.86},
        ]
      }
      else if (row.name === "CBLUE3.0"){
        this.models = [
          {name: "RoBERTa-adapter", precision: 0.73, f1: 0.77, recall: 0.82},
          {name: "chinese-bert", precision: 0.71, f1: 0.75, recall: 0.80},
          {name: "bert-crf", precision: 0.70, f1: 0.74, recall: 0.79},
        ]
      }
    },
    rowClassName({row, rowIndex}) {
      if(row === this.selectedDataset) {
        return 'highlight-row';
      }
      return '';
    },
    submitSelections() {
      // 提交用户选择的Dataset和模型给后端
    },
    getPreSettings(){ // 从Text标注工具后端获得当前Projects的参数
      axios({
        method: 'get',
        url: '/api/api/projects/'+this.project_id+'/presettings/',
        headers:{
          'X-CSRFToken': this.csrfToken,
          'Content-Type': 'application/json'
        },
      }).then(response => {
        if(response.status === 200){
          this.PreSettings = response.data
          console.log(this.PreSettings)
          this.saved = true
        }
      }).catch((error) => {
        // this.settingVisible = true
        alert('Settings are not initialized，please initialize first！')
      })
    },
    async sendModelBatchRequests() {
      const baseModelUrl = '/modelopsapi/modelrepos/';
      for (const model of this.allModel) {
        const url = `${baseModelUrl}${model.id}/`;
        const response = await axios.get(url);

        // 将响应数据添加到对应的元素上
        model.parameter = response.data.parameter;
      }
      console.log(this.allModel)
    },
    savePreSettings(){
        axios({
          method: 'put',
          url: '/api/api/projects/'+this.project_id+'/presettings/',
          headers:{
            'X-CSRFToken': this.csrfToken,
            'Content-Type': 'application/json'
          },
          data: this.PreSettings,
        }).then(response => {
          if(response.status === 200){
            // this.saved = true
            alert('Pre Annotation Settings Saved')
            this.saveSettings() // 保存Pre AnnotationSettings的时候同时需要保存正式阶段标注Settings，以免出现无法获得标注的情况
          }
        }).catch((error) => {
          alert('网络连接失败！')
        })
      // }
      // else{
      //   return
      // }
    },
    saveSettings(){
      axios({
        method: 'put',
        url: '/api/api/projects/'+this.project_id+'/settings/',
        headers:{
          'X-CSRFToken': this.csrfToken,
          'Content-Type': 'application/json'
        },
        data: this.settings,
      }).then(response => {
        if(response.status === 200){
          // this.saved = true
          this.$message('Settings Saved')
        }
      }).catch((error) => {
        this.$message('网络连接失败！')
      })
    },
    resetPreSettings(){ // 重置Pre AnnotationSettings
      this.PreSettings.preSetPercent = 10
      this.PreSettings.preSetAcc = 80
    },
  }
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.label-body{
  /* margin-left: 300px; */
  left: 350px;
  top: 15vh;
  position: absolute;
  height: 110%;
  width: 75%;
  overflow: auto;
  /* border-color: blueviolet;
  background-color: rgba(255, 255, 255, 0.7);; */
}
.multiline-text {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.upload-demo {
  margin-top: 20px;
  margin-bottom: 20px;
}
.input-demo {
  margin-top: 10px;
  margin-bottom: 20px;
}
.table-demo {
  margin-top: 20px;
  margin-bottom: 20px;
}
.row {
  display: flex;
  justify-content: space-between;
}
.col {
  width: 48%;
}
.highlight-row {
  background-color: #f5f7fa;
}
</style>
